export const ENTITY_CONDITIONAL_COLUMNS = [
  'diseaseName',
  'geneSymbol',
  'variantStrID',
  'strID',
  'chemPrefName',
  'chemID',
  'chemIDs',
  'chemsInSentence',
] as const;

export type ColumnVisibilityRecord = Record<string, boolean>;

export function applyEntityColumnDefaults(
  current: ColumnVisibilityRecord | undefined,
  defaults: ColumnVisibilityRecord | undefined,
): ColumnVisibilityRecord | undefined {
  if (!defaults) return current;
  if (!current) return { ...defaults };

  let changed = false;
  const next = { ...current };
  ENTITY_CONDITIONAL_COLUMNS.forEach(col => {
    if (defaults[col] !== undefined && next[col] !== defaults[col]) {
      next[col] = defaults[col];
      changed = true;
    }
  });
  return changed ? next : current;
}

export function mergeEntityColumnsIntoOrder(
  currentOrder: string[] | undefined,
  defaults: ColumnVisibilityRecord | undefined,
): string[] | undefined {
  if (!defaults) return currentOrder;
  const becomeVisible = ENTITY_CONDITIONAL_COLUMNS.filter(col => defaults[col] === true);
  const becomeVisibleSet = new Set<string>(becomeVisible);
  const becomeHidden = new Set<string>(ENTITY_CONDITIONAL_COLUMNS.filter(col => defaults[col] === false));
  const preserved = (currentOrder ?? []).filter(col => !becomeHidden.has(col) && !becomeVisibleSet.has(col));
  const visibleAlreadyInOrder = becomeVisible.filter(col => (currentOrder ?? []).includes(col));
  const visibleMissing = becomeVisible.filter(col => !visibleAlreadyInOrder.includes(col));
  return [...visibleMissing, ...visibleAlreadyInOrder, ...preserved];
}
